
// region JS Imports

// region External Modules
import $ from "jquery"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import { EventEmitter } from "events"
import I18n from "i18n-js"
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string | Element | JQuery
  main: string | Element | JQuery
  menu: string | Element | JQuery
  toggle: string | Element | JQuery
  toggle_text: string | Element | JQuery

  level_1_city_regions: string | Element | JQuery
  level_1_city_region: string | Element | JQuery
  level_2_city_regions: string | Element | JQuery
  level_2_city_region: string | Element | JQuery
  neighbourhoods: string | Element | JQuery
  neighbourhood: string | Element | JQuery
  select_all_neighbourhoods: string | Element | JQuery
  city_region_label: string | Element | JQuery

  select_menu: string | Element | JQuery
  selected_neighbourhood_items: string | Element | JQuery
  selected_neighbourhoods_full_close: string | Element | JQuery
  selected_neighbourhoods: string | Element | JQuery
  selected_neighbourhood: string | Element | JQuery
  selected_neighbourhood_count: string | Element | JQuery
  selected_neighbourhood_count_text: string | Element | JQuery
  selected_neighbourhood_suffix: string | Element | JQuery
  neighbourhood_option_filter: string | Element | JQuery
  city_region_options: string | Element | JQuery
  filtered_city_region_label: string | Element | JQuery
  clear_filter_input: string | Element | JQuery
  no_neighbourhood_option_found: string | Element | JQuery

  checkbox: string | Element | JQuery
  checked_checkbox: string | Element | JQuery
  arrow_right: string | Element | JQuery
}
export interface InputSelector {
  main?: string | Element | JQuery
  menu?: string | Element | JQuery
  checkbox?: string | Element | JQuery
  checked_checkbox?: string | Element | JQuery
}


const default_selector: Selector = {
  scope:              "body",
  main:               ".cell-listing-filter__filter-option--neighbourhoods",
  menu:               ".cell-listing-filter__filter-option--neighbourhoods_dropdown",
  toggle:             ".cell-listing-filter__filter-option--neighbourhoods_toggle",
  toggle_text:        ".cell-listing-filter__filter-option--neighbourhoods_toggle_text",

  level_1_city_regions:       ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__Level-1-city-regions",
  level_1_city_region:        ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__Level-1-city-region",
  level_2_city_regions:       ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__Level-2-city-regions",
  level_2_city_region:        ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__Level-2-city-region",
  neighbourhoods:             ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__neighbourhoods",
  neighbourhood:              ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__neighbourhood",
  select_all_neighbourhoods:  ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select_all",
  city_region_label:          ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__Level-2-city-region-label",

  checkbox:           "input[type=\"checkbox\"]",
  checked_checkbox:   "input[type=\"checkbox\"]:checked",

  select_menu:                            ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_select-menu",
  selected_neighbourhood_items:           ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhood_items",
  selected_neighbourhoods_full_close:     ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhoods_full-close",
  selected_neighbourhoods:                ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhoods",
  selected_neighbourhood:                 ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhood",
  selected_neighbourhood_count:           ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhood_count",
  selected_neighbourhood_count_text:      ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhood_count_text",
  selected_neighbourhood_suffix:          ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_selected_neighbourhood-suffix",

  neighbourhood_option_filter:    ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_filter",
  city_region_options:            ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__city_region_options",
  filtered_city_region_label:     ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__city_region_label",
  clear_filter_input:             ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option_filter-suffix",
  no_neighbourhood_option_found:  ".cell-listing-filter__filter-option--neighbourhoods_dropdown-option__select-menu__no-result-found",

  arrow_right:        ".arrow-right",
}


class NeighbourhoodSelectWithTerritoriesClass extends EventEmitter {
  private selector: Selector
  private readonly $main: JQuery
  private readonly main_el: HTMLElement
  private $scope: JQuery
  private $menu: JQuery
  private $toggle: JQuery
  private $toggle_text: JQuery

  private $level_1_city_regions: JQuery
  private $level_1_city_region: JQuery
  private $level_2_city_regions: JQuery
  private $level_2_city_region: JQuery
  private $neighbourhoods: JQuery
  private $neighbourhood: JQuery

  private $select_menu: JQuery
  private $selected_neighbourhood_items: JQuery
  private $selected_neighbourhoods_full_close: JQuery
  private $selected_neighbourhood_count: JQuery
  private $selected_neighbourhood_count_text: JQuery
  private $selected_neighbourhoods: JQuery

  private $neighbourhood_option_filter: JQuery
  private $city_region_options: JQuery
  private $filtered_city_region_label: JQuery
  private $clear_filter_input: JQuery
  private $no_neighbourhood_option_found: JQuery

  private $checkbox: JQuery
  private $all_checkbox: JQuery

  constructor(selector: InputSelector) {
    super()

    this.selector = Object.assign({}, default_selector, selector)

    this.$scope = $(this.selector.scope)
    this.$main = this.$scope.find(this.selector.main)
    this.main_el = this.$main[0] as HTMLElement
    this.$menu = this.$main.find(this.selector.menu)
    this.$toggle = this.$main.find(this.selector.toggle)
    this.$toggle_text = this.$toggle.find(this.selector.toggle_text)

    this.$level_1_city_regions = this.$main.find(this.selector.level_1_city_regions)
    this.$level_1_city_region = this.$level_1_city_regions.find(this.selector.level_1_city_region)
    this.$level_2_city_regions = this.$main.find(this.selector.level_2_city_regions)
    this.$level_2_city_region = this.$level_2_city_regions.find(this.selector.level_2_city_region)
    this.$neighbourhoods = this.$main.find(this.selector.neighbourhoods)
    this.$neighbourhood = this.$main.find(this.selector.neighbourhood)

    this.$select_menu = this.$main.find(this.selector.select_menu)
    this.$selected_neighbourhood_items = this.$main.find(this.selector.selected_neighbourhood_items)
    this.$selected_neighbourhoods_full_close = this.$main.find(this.selector.selected_neighbourhoods_full_close)
    this.$selected_neighbourhood_count = this.$main.find(this.selector.selected_neighbourhood_count)
    this.$selected_neighbourhood_count_text = this.$main.find(this.selector.selected_neighbourhood_count_text)
    this.$selected_neighbourhoods = this.$main.find(this.selector.selected_neighbourhoods)

    this.$neighbourhood_option_filter = this.$main.find(this.selector.neighbourhood_option_filter)
    this.$city_region_options = this.$main.find(this.selector.city_region_options)
    this.$filtered_city_region_label = this.$main.find(this.selector.filtered_city_region_label)
    this.$clear_filter_input = this.$neighbourhood_option_filter.find(this.selector.clear_filter_input)
    this.$no_neighbourhood_option_found = this.$main.find(this.selector.no_neighbourhood_option_found)

    this.$checkbox = this.$main.find(this.selector.checkbox)
    this.$all_checkbox = this.$main.find(this.selector.select_all_neighbourhoods).find(this.selector.checkbox)

    this.bind_action()
    this.selectedNeighbourhoodDisplay()
    this.updateToggleLabelTextAndStyle()
  }

  public count(): number {
    return this.$neighbourhood.find(this.selector.checked_checkbox).length || 0
  }

  public isDefault() {
    return this.count() === 0
  }
  public reset(){
    this.$checkbox.prop("checked", false)
    this.updateToggleLabelTextAndStyle()
  }

  private bind_action(){
    this.$toggle.on("click", () => {
      if (this.$menu.hasClass("active")) {
        this.onCloseMenu()
      }
      else {
        this.$menu.addClass("active")
      }

      this.setAllCheckBoxStatus()
      this.selectedNeighbourhoodDisplay()
      this.updateCityRegionLabel()
    })

    this.$level_1_city_region.each((_idx, el) => {
      const data = $(el).attr("data").toString()
      const name = $(el).attr("name").toString()

      // for default opening behavior
      if (_idx === 0)  {
        $(el).addClass("active")
        this.setDefaultBehavior(data)
      }

      // for default level 1 city region select behavior
      $(el).on("click", () => {
        this.setActive(this.$level_1_city_region, data)
        this.setDefaultBehavior(data)

        this.setAllCheckBoxStatus(
          I18n.t("simple_form.placeholders.listing_search.all_neighbourhood_within_city_region", {city_region_name: name})
        )
      })
    })

    this.$level_2_city_region.each((_idx, el) => {
      const data = $(el).attr("data").toString()
      const name = $(el).attr("name").toString()

      $(el).on("click", () => {
        this.setActive(this.$level_2_city_region, data)

        this.$neighbourhood.removeClass("active")
        if ($(el).attr("parent_city_region_id")) {
          this.$neighbourhood.filter(`[level_2_city_region=${data}]`).addClass("active")
        }
        else {
          this.$neighbourhood.filter(`[level_1_city_region=${data}]`).addClass("active")
        }

        let label_text = name

        if ($(el).attr("parent_city_region_id")) {
          label_text = I18n.t("simple_form.placeholders.listing_search.all_neighbourhood_within_city_region", {city_region_name: label_text})
        }

        this.setAllCheckBoxStatus(label_text)
      })
    })

    this.$checkbox.on("change", () => {
      this.onChange()
    })

    this.$all_checkbox.on("click", () => {
      this.$neighbourhood.each((_idx, el) => {
        if ($(el).hasClass("active")) {
          if (this.$all_checkbox.prop("checked")) {
            $(el).find(this.selector.checkbox).prop("checked", true)
          }
          else {
            $(el).find(this.selector.checkbox).prop("checked", false)
          }
        }
      })
    })

    this.$neighbourhood_option_filter.on("input", () => {
      const input_value = this.$neighbourhood_option_filter.find("input").val().trim()

      this.onFilterChange(input_value)
      this.selectedNeighbourhoodDisplay()
    })

    this.$clear_filter_input.on("click", () => {
      this.$neighbourhood_option_filter.find("input").val("")

      this.onFilterChange()
      this.setAllCheckBoxStatus()
      this.$clear_filter_input.hide()
    })

    this.$selected_neighbourhood_items.find(this.selector.selected_neighbourhood).each((_idx, el) => {
      const data = $(el).attr("data").toString()

      $(el).find(this.selector.selected_neighbourhood_suffix).on("click" , () => {
        this.$menu.find(this.selector.checked_checkbox).filter(`[value=${data}]`).prop("checked", false)
        this.onChange()
      })
    })

    // region for showing part/all selected neighbourhood label
    this.$selected_neighbourhood_count.on("click", () => {
      this.$select_menu.hide()

      this.$selected_neighbourhood_items.addClass("full")
      this.$selected_neighbourhoods_full_close.addClass("active")
      this.selectedNeighbourhoodDisplay()
    })

    this.$selected_neighbourhoods_full_close.on("click", () => {
      this.onShowLessSelectedNeighbourhoods()
      this.selectedNeighbourhoodDisplay()
    })
    // endregion for showing part/all selected neighbourhood label

    onClickOutside(this.main_el, () => {
      this.onCloseMenu()
    })

    return this
  }

  private onFilterChange(input_value = "") {
    this.$filtered_city_region_label.hide()
    this.$no_neighbourhood_option_found.hide()
    // reset all label texts' color to original
    this.$neighbourhood.each((_idx, el) => {
      const new_text = $(el).find("label").text().replace("<span style=\"color:#FF8700\">", "").replace("</span>", "")

      $(el).find("label").html(new_text)
    })

    if (input_value === "") {
      this.$neighbourhood.removeClass("active")
      this.$city_region_options.show()
      this.$clear_filter_input.hide()
      this.$all_checkbox.parent().show()

      this.$level_2_city_region.each((_idx, el) => {
        const data = $(el).attr("data").toString()

        if ($(el).hasClass("active") && $(el).hasClass("shown")) {
          if ($(el).attr("parent_city_region_id")) {
            this.$neighbourhood.filter(`[level_2_city_region=${data}]`).addClass("active")
          }
          else {
            this.$neighbourhood.filter(`[level_1_city_region=${data}]`).addClass("active")
          }

          return
        }
      })
    }
    else {
      this.$city_region_options.hide()
      this.$neighbourhoods.scrollTop(0)
      this.$clear_filter_input.show()
      this.$no_neighbourhood_option_found.show()
      this.$all_checkbox.parent().hide()

      this.$neighbourhood.each((_idx, el) => {
        $(el).removeClass("active")
        const label = $(el).attr("name")
        if (I18n.locale === "en") {
          const index = label.toLowerCase().indexOf(input_value.toLowerCase())

          if (index > -1) {
            const target_text = label.substring(index, index + input_value.length)

            this.$no_neighbourhood_option_found.hide()
            this.$filtered_city_region_label.filter(`[level_1_city_region=${$(el).attr("level_1_city_region")}]`).show()

            // update filtered label text color to red
            const new_text = $(el).find("label").text().replace(target_text, `<span style="color:#FF8700">${target_text}</span>`)

            $(el).find("label").html(new_text)
            $(el).addClass("active")
          }
        }
        else {
          if (label.includes(input_value)){
            this.$no_neighbourhood_option_found.hide()
            this.$filtered_city_region_label.filter(`[level_1_city_region=${$(el).attr("level_1_city_region")}]`).show()

            // update filtered label text color to red
            const new_text = $(el).find("label").text().replace(input_value, `<span style="color:#FF8700">${input_value}</span>`)

            $(el).find("label").html(new_text)
            $(el).addClass("active")
          }
        }
      })
    }
  }

  private setDefaultBehavior(data: string) {
    this.$level_2_city_region.removeClass("shown")
    this.$level_2_city_region.removeClass("active")
    this.$level_2_city_region.filter(`[data=${data}]`).addClass("shown")
    this.$level_2_city_region.filter(`[parent_city_region_id=${data}]`).addClass("shown")

    this.$level_2_city_region.filter(`[data=${data}]`).addClass("shown").addClass("active")
    this.$level_2_city_region.filter(`[data=${data}]`).addClass("shown").find(this.selector.arrow_right).addClass("active")

    this.$neighbourhood.removeClass("active")
    this.$neighbourhood.filter(`[level_1_city_region=${data}]`).addClass("active")
  }

  private setActive(inputJquery :JQuery<HTMLElement>, data: string) {
    inputJquery.removeClass("active")
    inputJquery.find(this.selector.arrow_right).removeClass("active")

    inputJquery.filter(`[data=${data}]`).addClass("active")
    inputJquery.find(this.selector.arrow_right).filter(`[data=${data}]`).addClass("active")
  }

  private selectedNeighbourhoodDisplay() {
    // reset to default
    $(this.selector.selected_neighbourhood).removeClass("active")
    this.$selected_neighbourhoods.removeClass("active")

    if (this.count() === 0) return

    this.$selected_neighbourhoods.addClass("active")

    this.$menu.find(this.selector.checked_checkbox).each((_id, el) => {
      this.$selected_neighbourhood_items.find(this.selector.selected_neighbourhood).each((_idy, ele) => {
        const data = $(ele).attr("data").toString()

        if ($(el).val().toString() === data) {
          if (this.count() > 4 && this.$selected_neighbourhood_items.find(this.selector.selected_neighbourhood).filter(".active").length === 3 && !this.$selected_neighbourhood_items.hasClass("full")) {
            this.$selected_neighbourhood_count_text.text(
              I18n.t("simple_form.placeholders.listing_search.see_all", {selected_neighbourhoods_count: this.count() })
            )
            this.$selected_neighbourhood_count.show()

            return
          }

          this.$selected_neighbourhood_count.hide()
          $(ele).addClass("active")
        }
      })
    })
  }

  private setAllCheckBoxStatus(label_text = "") {
    // update checkbox label
    if (label_text !== ""){
      this.$all_checkbox.parent().find(".cell-listing-filter--neighbourhood--label").text(label_text)
    }

    // update checkbox status
    const total_number_of_active_checkbox = this.$neighbourhood.filter(".active").length
    const total_number_of_active_checked_checkbox = this.$neighbourhood.filter(".active").find(this.selector.checked_checkbox).length

    this.$all_checkbox.prop("checked", total_number_of_active_checkbox === total_number_of_active_checked_checkbox)
  }

  private updateCityRegionLabel() {
    this.$level_1_city_region.each((_idx, el) => {
      const data = $(el).attr("data").toString()
      const name = $(el).attr("name").toString()

      const count = this.$neighbourhood.filter(`[level_1_city_region=${data}]`).find(this.selector.checked_checkbox).length

      if (count > 0) {
        $(el).find(this.selector.city_region_label).text(`${name} (${count})`)
      }
      else {
        $(el).find(this.selector.city_region_label).text(name)
      }
    })

    this.$level_2_city_region.each((_idx, el) => {
      const data = $(el).attr("data").toString()
      const name = $(el).attr("name").toString()
      const target_data = $(el).attr("parent_city_region_id") ? "level_2_city_region" : "level_1_city_region"
      const count = this.$neighbourhood.filter(`[${target_data}=${data}]`).find(this.selector.checked_checkbox).length

      if (count > 0) {
        $(el).find(this.selector.city_region_label).text(`${name} (${count})`)
      }
      else {
        $(el).find(this.selector.city_region_label).text(name)
      }
    })
  }

  private onChange(){
    this.emit("val_change")
    this.selectedNeighbourhoodDisplay()
    this.setAllCheckBoxStatus()
    this.updateCityRegionLabel()
    this.updateToggleLabelTextAndStyle()
  }

  private onCloseMenu() {
    this.$menu.removeClass("active")
    this.$neighbourhood_option_filter.find("input").val("")
    this.onFilterChange()
    this.onShowLessSelectedNeighbourhoods()
  }

  private onShowLessSelectedNeighbourhoods() {
    this.$select_menu.show()

    this.$selected_neighbourhood_items.scrollTop(0)
    this.$selected_neighbourhood_items.removeClass("full")
    this.$selected_neighbourhoods_full_close.removeClass("active")
  }

  private updateToggleLabelTextAndStyle() {
    const label_text = I18n.t("simple_form.placeholders.listing_search.select_neighbourhoods")
    this.$toggle_text.removeAttr("style")
    this.$toggle.find("i").removeAttr("style")
    this.$toggle_text.text(label_text)

    if (this.count() > 0) {
      this.$toggle_text.css("font-weight", "bold")
      this.$toggle.find("i").css("font-weight", "bold")
      this.$toggle_text.text(`${label_text} (${this.count()})`)
    }
  }
}

export {
  NeighbourhoodSelectWithTerritoriesClass,
}
